export var Placement;
(function (Placement) {
    Placement["TOP"] = "top";
    Placement["RIGHT"] = "right";
    Placement["LEFT"] = "left";
    Placement["BOTTOM"] = "bottom";
})(Placement || (Placement = {}));
export var DrawerVariant;
(function (DrawerVariant) {
    DrawerVariant["DEFAULT"] = "default";
    DrawerVariant["SIDE_PANEL"] = "sidePanel";
    DrawerVariant["FULL_CONTENT"] = "fullContent";
})(DrawerVariant || (DrawerVariant = {}));
//# sourceMappingURL=Drawer.types.js.map